import { Component } from '@angular/core';
import { BrandConfigQuery } from '@app/store/brand/brand.query';
import { BrandConfig } from '@models/BrandConfig';
import { Observable } from 'rxjs';

@Component({
	standalone: false,
	selector: 'qe-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
	public readonly brandConfig$: Observable<BrandConfig>;

	constructor(
		private readonly brandConfigState: BrandConfigQuery,
	) {
		this.brandConfig$ = this.brandConfigState.brandConfig$();
	}
}
